import { computed, observable } from "mobx";

export default class Address {
  /**
   * @property {number|null}
   */
  @observable addressId = null;

  /**
   * @property {string}
   */
  @observable street = "";

  /**
   * @property {string}
   */
  @observable street2 = "";

  /**
   * @property {string}
   */
  @observable city = "";

  /**
   * @property {string}
   */
  @observable state = "";

  /**
   * @property {string}
   */
  @observable zip = "";

  /**
   * @property {string}
   */
  @observable country = "";

  constructor({ addressId = null, street = "", street2 = "", city = "", state = "", zip = "", country = "" }) {
    this.addressId = addressId;
    this.street = street;
    this.street2 = street2;
    this.city = city;
    this.state = state;
    this.zip = zip;
    this.country = country;
  }

  @computed
  get fullStreet() {
    return [this.street].filter(Boolean).join(" ");
  }

  /**
   * Coarse location query used for geocoding. Anchored on the postal code —
   * street lines are never included so free-form input (units, suites,
   * abbreviations) cannot break geolocation. Falls back to city/state for
   * countries without postal codes.
   */
  getGeolocatableAddress() {
    const parts = this.zip ? [this.zip, this.country] : [this.city, this.state, this.country];

    return parts
      .filter(Boolean)
      .join(", ")
      .trim();
  }

  getMappableAddress() {
    // e.g `street street2, city state zip, country`.
    const part1 = [this.street, this.street2].filter(Boolean).join(" ");
    const part2 = [this.city, this.state, this.zip].filter(Boolean).join(" ");
    const part3 = this.country;

    return [part1, part2, part3]
      .filter(Boolean)
      .join(", ")
      .trim();
  }

  /**
   * "inline" refers to  the input name for the corresponding Address.jsx component where a full address text
   * can be searched for and selected.
   */
  @computed
  get inline() {
    return this.getMappableAddress();
  }
}
